module.exports = __webpack_public_path__ + "img/syimg2.035e0d32.png";